import { INotification } from '@/interfaces/common.model';
import { timeAgo } from '@/utility/CommonFunctions';
import { getNotificationUrl } from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'reactstrap';
interface INotificationModalProps {
  isLoading: boolean;
  notifications: INotification[] | null;
}

const NotificationModal = ({
  isLoading,
  notifications,
}: INotificationModalProps) => {
  const navigate = useNavigate();
  return (
    <ul className="dropdown-menu shadow notification-dropdown">
      <li className="head d-flex align-items-center justify-content-between">
        <h3 className="mb-0">Notifications</h3>

        {/* <span className="badge bg-green-25 small" style={{ fontSize: '1rem' }}>
          4 New
        </span> */}
      </li>
      <li className="body">
        <ul className="list-unstyled notification_inner">
          {isLoading && (
            <div className="d-flex justify-content-center my-4">
              <Spinner color="primary" />
            </div>
          )}
          {notifications && notifications?.length > 0
            ? notifications?.map(
                (item, i) =>
                  i < 10 && (
                    <li key={i}>
                      <Link
                        to={getNotificationUrl(item)}
                        // state={
                        //   item?.data?.type == "leave"
                        //     ? userDetails?.type == 2
                        //       ? { type: "request" }
                        //       : { type: "teamLeaveRequest" }
                        //     : null
                        // }
                      >
                        <div
                          className="d-flex justify-content-between"
                          // onClick={() => handleNavigateTabs(item)}
                        >
                          <h4 className="title mb-0">{item?.data?.title}</h4>
                          <span className="time">
                            {timeAgo(item?.createdAt)}
                          </span>
                        </div>
                        <p>{item?.data?.message}</p>
                      </Link>
                    </li>
                  ),
              )
            : !isLoading && (
                <li className="text-muted text-center">
                  <p>No Notifications</p>
                </li>
              )}
        </ul>
      </li>

      <li className="footer">
        <a
          className="fs-4 text-center d-block"
          onClick={() => navigate(RoutesLink?.notification)}
        >
          View All
        </a>
      </li>
    </ul>
  );
};
export default NotificationModal;
